export default {
  methods: {
    caltPA(wtUnit) {
      var tPAwt = 100;

      if (wtUnit == 'lbs') {
        tPAwt = (parseFloat(document.tPAForm.wtlbs.value) / 2.2046).toFixed(1);
        document.tPAForm.wtkg.value = tPAwt;
      } else {
        tPAwt = parseFloat(document.tPAForm.wtkg.value);
        document.tPAForm.wtlbs.value = (tPAwt * 2.2046).toFixed(0);
      }

      document.getElementById('PtWt').innerHTML = tPAwt;
      var tPAdose = (0.9 * tPAwt).toFixed(1);

      if (tPAdose > 90) {
        tPAdose = 90.0;
      }

      document.getElementById('tPAdraw').innerHTML = tPAdose;
      document.getElementById('tPAtotaldose').innerHTML = tPAdose;
      document.getElementById('tPAbolus').innerHTML = (tPAdose * 0.1).toFixed(1);
      document.getElementById('tPAdiscard').innerHTML = (100 - tPAdose).toFixed(1);
      document.getElementById('tPArate').innerHTML = (tPAdose * 0.9).toFixed(1);
    }

  },
  id: '22401e57a2',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=tPA><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>tPA</div></div></div><div class=page-content><form name=tPAForm><div class=block-header>WEIGHT (AUTOCONVERT)</div><div class="list simple-list"><ul><li><span>Enter weight in pounds:</span><div class=item-input style=width:15%;><input name=wtlbs placeholder=lbs&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input="caltPA(\'lbs\');"></div></li><li><span>Enter weight in kilograms:</span><div class=item-input style=width:15%;><input name=wtkg placeholder=kg&nbsp;&nbsp;&nbsp; type=number value="" style="text-align: right;" @input="caltPA(\'kg\');"></div></li></ul></div><div class=block-header>MIXING tPA (100mg vial)</div><div class="list simple-list"><ul><li><span>Patient\'s weight:</span><div class=float-right><span id=PtWt></span>&nbsp;kg</div></li><li><span>tPA volume drawn:</span><div class=float-right><span id=tPAdraw></span>&nbsp;ml</div></li><li><span>Discard volume:</span><div class=float-right><span id=tPAdiscard></span>&nbsp;ml</div></li></ul><div class=block-footer>Mixed bottle: tPA 100mg in 100ml (1:1)</div></div><div class=block-title>ADMINISTRATION (Time-out and recheck!)</div><div class="list simple-list"><ul><li><span>Total tPA (0.9mg/kg <i>max 90mg</i>):</span><div class=float-right><span id=tPAtotaldose></span>&nbsp;mg</div></li><li><span>Bolus 10% (1 min):</span><div class=float-right><span id=tPAbolus></span>&nbsp;ml</div></li><li><span>Infusion 90% (60mins):</span><div class=float-right><span id=tPArate></span>&nbsp;ml/hr</div></li></ul></div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};